<template>
  <span
    class="cursor-pointer"
    role="button"
    tabindex="0"
    @click="copyText"
    @keydown.enter.prevent="copyText"
    @keydown.space.prevent="copyText"
    :aria-label="label || 'Copy to clipboard'"
    :title="label ? '' : 'Click to copy'"
  >
    <span v-if="label">{{ label }} </span>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="w-4 h-4 color-gray-500" fill="currentColor" style="width: 14px; height: 14px; vertical-align: middle;">
      <path d="M314.222 197.78c51.091 51.091 54.377 132.287 9.75 187.16-6.242 7.73-2.784 3.865-84.94 86.02-54.696 54.696-143.266 54.745-197.99 0-54.711-54.69-54.734-143.255 0-197.99 32.773-32.773 51.835-51.899 63.409-63.457 7.463-7.452 20.331-2.354 20.486 8.192a173.31 173.31 0 0 0 4.746 37.828c.966 4.029-.272 8.269-3.202 11.198L80.632 312.57c-32.755 32.775-32.887 85.892 0 118.8 32.775 32.755 85.892 32.887 118.8 0l75.19-75.2c32.718-32.725 32.777-86.013 0-118.79a83.722 83.722 0 0 0-22.814-16.229c-4.623-2.233-7.182-7.25-6.561-12.346 1.356-11.122 6.296-21.885 14.815-30.405l4.375-4.375c3.625-3.626 9.177-4.594 13.76-2.294 12.999 6.524 25.187 15.211 36.025 26.049zM470.958 41.04c-54.724-54.745-143.294-54.696-197.99 0-82.156 82.156-78.698 78.29-84.94 86.02-44.627 54.873-41.341 136.069 9.75 187.16 10.838 10.838 23.026 19.525 36.025 26.049 4.582 2.3 10.134 1.331 13.76-2.294l4.375-4.375c8.52-8.519 13.459-19.283 14.815-30.405.621-5.096-1.938-10.113-6.561-12.346a83.706 83.706 0 0 1-22.814-16.229c-32.777-32.777-32.718-86.065 0-118.79l75.19-75.2c32.908-32.887 86.025-32.755 118.8 0 32.887 32.908 32.755 86.025 0 118.8l-45.848 45.84c-2.93 2.929-4.168 7.169-3.202 11.198a173.31 173.31 0 0 1 4.746 37.828c.155 10.546 13.023 15.644 20.486 8.192 11.574-11.558 30.636-30.684 63.409-63.457 54.733-54.735 54.71-143.3-.001-197.991z"/>
    </svg>
  </span>
</template>
<script>
export default {
  name: 'copy-icon',
  props: {
    text: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
  },
  methods: {
    async copyText() {
      // Prefer the modern Clipboard API, but it requires a secure context
      // (https / localhost) and a focused document. Fall back to the legacy
      // textarea + execCommand trick when it isn't available or throws.
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(this.text);
          this.$notificationManager.emit('show-toast', 'Copied to clipboard', true);
          return;
        }
      } catch (e) {
        // fall through to legacy path
      }

      if (this.legacyCopy(this.text)) {
        this.$notificationManager.emit('show-toast', 'Copied to clipboard', true);
      } else {
        this.$notificationManager.emit('show-toast', 'Unable to copy to clipboard', false);
      }
    },
    legacyCopy(text) {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      // Off-screen but still selectable
      textarea.style.position = 'fixed';
      textarea.style.top = '0';
      textarea.style.left = '0';
      textarea.style.opacity = '0';
      textarea.setAttribute('readonly', '');
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      let succeeded = false;
      try {
        succeeded = document.execCommand('copy');
      } catch (e) {
        succeeded = false;
      }
      document.body.removeChild(textarea);
      return succeeded;
    },
  },
};
</script>
